import { isSerializedAssemblyRow, type AssemblyWorkOrderListRow } from "./assemblyApi";
import type { WorkOrderListRow } from "./workOrdersPageModel";
import { effectiveWorkOrderReceivedQuantity, effectiveWorkOrderStatus } from "./workOrdersPageModel";

export type AssemblyListRow = WorkOrderListRow & AssemblyWorkOrderListRow;

export function workOrderStatusLabel(row: AssemblyListRow): string {
  const status = effectiveWorkOrderStatus(row);
  if (status !== "Unknown") return status;
  return row.stocking ? "Stocking" : "Open";
}

export function assemblyTypeLabel(row: AssemblyListRow): string {
  if (row.assembly_type === "serialized") return "Serialized";
  if (row.assembly_type === "build_order") {
    return /-TLA/i.test(row.sku ?? "") ? "TLA" : "Build";
  }
  return "Label";
}

export function assemblyTypeBadgeTone(row: AssemblyListRow): "info" | "neutral" {
  return row.assembly_type === "label" ? "neutral" : "info";
}

export function assemblyProgressLabel(row: AssemblyListRow): string {
  if (isSerializedAssemblyRow(row)) {
    return `${String(row.certified_count)} / ${String(row.quantity)} assembled`;
  }
  if (row.assembly_type === "build_order") {
    const received = effectiveWorkOrderReceivedQuantity(row);
    return `${String(received)} / ${String(row.quantity)}`;
  }
  return String(row.quantity);
}

export function formatAssemblyInstructionRevisionDate(value: string | null | undefined): string {
  if (value == null || value.trim() === "") return "";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export function assemblyInstructionRevisionTitleSuffix(
  revision: number | null,
  approvedAt: string | null,
): string | null {
  if (revision == null) return null;
  const approvedDate = formatAssemblyInstructionRevisionDate(approvedAt);
  return approvedDate !== "" ? `Revision ${String(revision)} · ${approvedDate}` : `Revision ${String(revision)}`;
}
